import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import {getLocalStorage} from '@/Utils/CommonUtils';

export default function usePointsHistoryApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const mutation = useMutation<
    any,
    any,
    {
      playerId: number | string;
    },
    unknown
  >(
    async payload => {
      const token = await getLocalStorage('access_token');
      const response = await ChessRestClient.get(
        `/v1/get_league_statement_of_player`,
        {
          params: {
            playerId: payload.playerId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        },
      );
      console.log('Retrieved profile = ', response.data);
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        } else if (handleOnError) {
          handleOnError(data);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
